export default __webpack_public_path__ + "static/media/icn-inverted-female.6eb8663a.svg";